import axios from "axios";

import type { ApiKey } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client";

export const getApiKeysByChatbotId = queryOptions({
	async queryFn({ queryKey }) {
		const [, { chatbotId }] = queryKey;
		const response = await axios.get<ApiKey[]>(`${env.apiUrl}/api-keys/chatbot/${chatbotId}`);

		return response.data;
	},
	queryKey: "apiKeysByChatbotId",
});

export async function createApiKeyByChatbotId({
	chatbotId,
	name,
}: {
	chatbotId: string;
	name: string;
}) {
	const response = await axios.post<ApiKey & { rawKey: string }>(
		`${env.apiUrl}/api-keys/chatbot/${chatbotId}`,
		{ name },
	);

	return response.data;
}

export async function revokeApiKey({ id }: { id: string }) {
	const response = await axios.delete<{ success: boolean }>(`${env.apiUrl}/api-keys/${id}`);

	return response.data;
}
